import React, { FC } from "react";
import { Badge, Col, Row, Tag } from "antd";
import classes from "./style/ApplicationCard.module.css";
import OrgDescription from "../OrgDescription/OrgDescription";
import dayjs from "dayjs";

import { PraiceSpace } from "../../../utils/utilities/PraiceSpace";
import { ApplicationBankCardData } from "../../../store/types/applicationBankList.type";

dayjs.locale("ru");

// Карточка заявки в списке всех заявок
export const ApplicationCard: FC<ApplicationBankCardData> = (props) => {
  const {
    created_at,
    updated_at,
    modified_bank_status,
    id: applicationBankId,
  } = props;
  const { inn, name } = props.application.organization;
  const { fz, purchase_number } = props.application.purchase ?? {};
  const nameBG = props.application.bg_type.name;

  const initialValues = {
    organization: `${name}`,
    inn: `${inn}`,
    number: props.id,
    date: `Дата: ${dayjs(created_at)?.format("DD.MM.YYYY  HH:mm")}`,
    purchase_number: purchase_number,
    sum: `${props.application.total_sum}`,
    status: status,
    link: `${props.application.link}`,
    fz: `${fz}`,
    bg_name: `${nameBG}`,
    name: name,
    sum_bg: `${props.application.application_sum_bg}`,
  };
  /* const sum_bg = getSumBg(
    props.application.bg_type?.id,
    props.application.purchase_lot
  ); */

  return (
    <>
      <div className={classes.cardWrapper}>
        <div className={classes.card}>
          {/* <RoleComponentRender roles={[AGENT, CLIENT]}> */}
          <Row>
            <Col
              xs={24}
              sm={5}
              md={5}
              lg={4}
              xl={4}
              className={classes.applicationCol}
            >
              <Badge
                // dot={props.application.read}
                style={{ width: "11px", height: "11px" }}
                offset={[10, 5]}
              >
                <div className={classes.applicationTitle}>
                  № {applicationBankId}
                </div>
              </Badge>
              <div className={classes.applicationDate}>
                Создана: {dayjs(created_at).format("DD.MM.YYYY HH:mm")}
              </div>
              {created_at !== updated_at && (
                <div className={classes.applicationDate}>
                  Изменена: {dayjs(updated_at).format("DD.MM.YYYY HH:mm")}
                </div>
              )}

              {/* <Guard.Role
                roles={[USER.BANK_AGENT_SIMPLE, USER.SUPPORT_ADMIN, USER.MANAGER]}
              >
                <div className={classes.applicationDate}>
                  Заявитель:{" "}
                  <Link
                    to={`/list-agent/${agent?.id}`}
                    onClick={(event) => event.stopPropagation()}
                  >
                    {agentName}
                  </Link>
                </div>
              </Guard.Role> */}
              <div className={classes.tagApplication}>
                <Tag color={modified_bank_status?.color}>
                  {modified_bank_status?.title}
                </Tag>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={9}
              lg={10}
              xl={10}
              className={classes.applicationCol}
            >
              <OrgDescription {...initialValues} header={true} />
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={9}>
              <div className={classes.infoBankStatus}>Сумма БГ</div>
              <div className={classes.infoSummApplication}>
                {PraiceSpace(initialValues.sum_bg)}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
